/**
 * Constants and utilities for crop zone area type selection
 * Used across Application components to maintain consistency
 */

// Area type constants
export const AREA_TYPE_REPORTED = 'reported' as const;
export const AREA_TYPE_BOUNDARY = 'boundary' as const;

export type AreaType = typeof AREA_TYPE_REPORTED | typeof AREA_TYPE_BOUNDARY;

/**
 * Helper function to determine the default area type for a crop zone
 * @param reportedArea - The reported area value for the crop zone
 * @returns The default area type ('reported' if reportedArea > 0, otherwise 'boundary')
 */
export const getDefaultAreaType = (reportedArea?: number): AreaType => {
  return reportedArea && reportedArea > 0
    ? AREA_TYPE_REPORTED
    : AREA_TYPE_BOUNDARY;
};
